export default __webpack_public_path__ + "e2f600a8cb97ce3efe4d3db463e6af48.svg";